module.exports = __webpack_public_path__ + "static/media/so-icon__four.19a34559.svg";